<template>
  <div>
    <!-- <v-select
      v-model="actualPrinter"
      :options="printers"
      class="margin-multi sp-border-input bg-white w-25 mb-2"
      placeholder="Impresora"
    />-->
    <CRow>
      <CCol sm="12" class="p-0">
        <CCard>
          <div
            class="px-3 flex-column flex-md-row py-2 d-flex justify-content-between w-100 border-bottom align-items-center"
          >
            <h5>Análisis</h5>
            <div class="d-flex align-items-center justify-content-center flex-wrap flex-sm-nowrap">
              <DateSelector initDates="week" @input="e => changeDate(e)" class="margi-dates" />
            </div>
          </div>
          <CCardBody class="p-0 pt-2">
            <CNav justified variant="tabs">
              <CNavItem :to="{
            name: 'Analisis'
          }">Análisis por ubicación</CNavItem>
              <CNavItem
                :to="{
            name: 'AnalisisNomina'
          }"
                active
              >Análisis de nómina</CNavItem>
              <CNavItem
                :to="{
            name: 'AnalisisEficiencia'
          }"
              >Análisis de eficiencia</CNavItem>
            </CNav>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="12" class="p-0">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex sp-flex justify-content-between text-sm align-items-center catalogo-text"
          >Análisis por nómina</CCardHeader>

          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th class="custom-width-space" scope="col">Tipo</th>
                  <th class="custom-width-space" scope="col">Hrs. normales</th>
                  <th class="custom-width-space" scope="col">Hrs. extras</th>
                  <th class="custom-width-space" scope="col">Pago variable</th>

                  <th class="custom-width-space" scope="col">Bonos</th>
                  <th class="custom-width-space" scope="col">Caja</th>
                  <th class="custom-width-space" scope="col">Préstamo</th>

                  <th class="custom-width-space" scope="col">Impuestos</th>
                  <th class="custom-width-space" scope="col">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isLoading">
                  <td :colspan="fields.length">
                    <div class="w-100 d-flex justify-content-center align-items-center">
                      <div class="sk-flow d-flex align-items-center">
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 1 && !isLoading" class="d-table-row">
                  <td class="py-2 cursor-p custom-width-space" @click="toggleHeaders(1)">
                    <span>
                      <CIcon name="cil-chevron-circle-down-alt" />
                    </span>
                    Trabajadores
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.hora
                    ? totalTrabajador.hora
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.horaExtra
                    ? totalTrabajador.horaExtra
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.variable
                    ? totalTrabajador.variable
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>

                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.bono
                    ? totalTrabajador.bono
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.caja
                    ? totalTrabajador.caja
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.prestamos
                    ? totalTrabajador.prestamos
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>
                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.impuestos
                    ? totalTrabajador.impuestos
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>

                  <td @click="toggleTotal(1)" class="custom-width-space cursor-p">
                    ${{
                    totalTrabajador.total
                    ? totalTrabajador.total
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "0"
                    }}
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 1 && !isLoading" class="d-table-row ml-4">
                  <td class="m-0 p-0" :colspan="fields.length">
                    <CCollapse :show="headersDetails.includes(1)">
                      <CDataTable
                        bordered
                        small
                        fixed
                        class="mb-0"
                        addTableClasses="mb-0"
                        :header="false"
                        :loading="isLoading"
                        :items="itemsEgresos"
                        :fields="fields"
                        :noItemsView="noItems"
                      >
                        <template #nombre="{item, index}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            <span @click="openModal(item)">
                              <CIcon name="cil-library" class="cursor-p mr-1" />
                            </span>
                            {{ item.payload.nombre }}
                          </td>
                        </template>
                        <template #hora="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.hora.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </td>
                        </template>
                        <template #horaExtra="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.horaExtra.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                            )
                            }}
                          </td>
                        </template>

                        <template #bono="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.bono.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                            )
                            }}
                          </td>
                        </template>
                        <template #caja="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.caja.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                            )
                            }}
                          </td>
                        </template>
                        <template #prestamos="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.prestamos.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                            )
                            }}
                          </td>
                        </template>

                        <template #variable="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.variable.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                            )
                            }}
                          </td>
                        </template>
                        <template #impuestos="{item}">
                        <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{item.impuestos.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                          </td>
                        </template>
                        <template #total="{item}">
                          <td
                            class="custom-width-space"
                            :class="
                              `${
                                items.filter(
                                  hijo => hijo.payload.pertenece_id == item.id
                                ).length > 0
                                  ? `cursor-p`
                                  : ``
                              }`
                            "
                            @click="toggleUbicaciones(index, 1)"
                          >
                            {{
                            item.total.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </td>
                        </template>
                      </CDataTable>
                    </CCollapse>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      :show.sync="infoModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Trabajador"
      color="info"
    >
      <!-- <h5 class="text-center">
        Trabajador
      </h5>-->
      <CRow>
        <CCol sm="6">
          <CCallout color="info">
            <small class="text-muted">{{itemModal && itemModal.payload.unidad}} normal</small>
            <br />
            <strong class="h3">
              {{
              itemModal
              ? String(
              itemModal.totalHoraNormal.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
              )
              )
              : `0`
              }}
            </strong>
          </CCallout>
        </CCol>
        <CCol sm="6">
          <CCallout color="primary">
            <small class="text-muted">{{itemModal && itemModal.payload.unidad_extra}} extra</small>
            <br />
            <strong class="h4">
              {{
              itemModal
              ? String(
              itemModal.totalHoraExtra.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
              )
              )
              : `0`
              }}
            </strong>
          </CCallout>
        </CCol>
        <!-- <CCol sm="4">
          <CCallout color="success">
            <small class="text-muted">Variables</small><br />
            <strong class="h4"
              >${{
                itemModal
                  ? String(
                      itemModal.totalVariable.replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      )
                    )
                  : `0`
              }}</strong
            >
          </CCallout>
        </CCol>-->
      </CRow>

      <CDataTable
        bordered
        small
        fixed
        class="mb-0"
        addTableClasses="mb-0"
        :items="itemsModal"
        :fields="fieldsModal"
        :noItemsView="noItems"
      ></CDataTable>

      <template #header>
        <h5 class="modal-title">{{ itemModal ? itemModal.payload.nombre : "" }}</h5>
        <CButtonClose @click="infoModal = false" class="text-white" />
      </template>
      <template #footer>
        <!-- <CButton @click="infoModal = false" color="danger">Cancelar</CButton> -->
        <CButton v-show="false" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import DateSelector from "../../../customComponents/DateSelector";
import axios from "axios";
import moment from "moment";

const fields = [
  { key: "nombre", _style: "width:0%" },
  { key: "hora", _style: "width:18%" },
  { key: "horaExtra", _style: "width:18%" },
  { key: "variable", _style: "width:18%" },

  { key: "bono", _style: "width:18%" },
  { key: "caja", _style: "width:18%" },
  { key: "prestamos", _style: "width:18%" },
  { key: "impuestos", _style: "width:18%" },

  { key: "total", _style: "width:18%" }
];

const fieldsModal = [
  { key: "actividad", label: "Actividades variables", _style: "width33%" },
  { key: "cantidad", _style: "width:33%" },
  { key: "unidad", _style: "width:33%" }
];

const fieldsHeaders = [
  { key: "name", label: "", _style: "width:20%" },
  { key: "labores", label: "Labores", _style: "width:20%" },
  { key: "productos", label: "Productos", _style: "width:20%" },
  { key: "gastos", label: "Gastos", _style: "width:20%" },
  { key: "total", label: "Total", _style: "width:20%" }
];


export default {
  name: "AnalisisNomina",

  components: {
    DateSelector
  },

  data() {
    return {
      items: [],
      itemsAnalisis: [],
      itemsModal: [],
      itemsProduccion: [],
      itemsIngresos: [],
      itemsEgresos: [],
      cultivos: [],
      fields,
      fieldsModal,
      fieldsHeaders,
      filter: "",
      dropdownCustom: false,
      allSelections: false,
      cancelModal: false,
      details: [],
      infoModal: false,
      actualAnalisis: 1,
      detailEgresos: [],
      detailProduccion: [],
      headersDetails: [],
      totalDetails: [],
      isLoading: false,
      printModal: false,
      cancelSource: null,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      itemModalPrint: { cantidadCopias: 1 },
      itemModal: null,

      totalTrabajador: {
        name: "",
        hora: 0,
        horaExtra: 0,

        bono: 0,
        caja: 0,
        prestamos: 0,

        variable: 0,
        impuestos: 0,
        total: 0
      },
      totalProduccion: {
        name: "",
        labores: "",
        productos: "",
        gastos: "",
        total: ""
      },
      headersItems: [
        {
          name: "Egresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Ingresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Producción",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        }
      ],
      egresosTotal: [
        {
          name: "Total",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Ingresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Producción",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        }
      ]
    };
  },

  created() {
    this.updateAllInfo();
  },

  computed: {
    printers() {
      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
    filteredItems() {
      return this.itemsEgresos.filter(i => i.payload.pertenece_id == 0);
      // .filter(i =>
      //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      // );
    },
    filteredItemsIngresos() {
      return this.itemsIngresos.filter(i => i.payload.pertenece_id == 0);
    },
    filteredItemsProduccion() {
      return this.itemsProduccion.filter(i => i.payload.pertenece_id == 0);
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.searchTimeOut();
    },
    actualAnalisis: function() {
      this.searchTimeOut();
    },
    datesGraph: function() {
      this.searchTimeOut();
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.updateAllInfo();
      }, 800);
    },
    onClickPrintCodes() {
      this.printModal = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);

      idsToPrint.length
        ? idsToPrint.map(ubicacion => {
            this.printNanoid(ubicacion, this.itemModalPrint.cantidadCopias);
          })
        : null;

      this.printModal = false;
    },
    printNanoid(ubicacion, cant) {
      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.filter(
        cultivo => cultivo.id == cultivo_id
      );

      return cultivoActual[0].payload.nombre;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    toggleUbicaciones(index, type) {
      const item = { index: index, type: type };

      const position = this.details.findIndex(item => item.type == type);

      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(item);
    },
    toggleTotal(index) {
      const position = this.totalDetails.indexOf(index);
      position !== -1
        ? this.totalDetails.splice(position, 1)
        : this.totalDetails.push(index);
    },
    toggleHeaders(index) {
      const position = this.headersDetails.indexOf(index);
      position !== -1
        ? this.headersDetails.splice(position, 1)
        : this.headersDetails.push(index);
    },
    deleteUbicacion(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "ubicaciones",
          id: id
        })
        .then(() => {
          // console.log(res.data);
        })
        .catch(() => {
          // console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    },

    updateAllInfo() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      const call = [
        this.$store.dispatch(
          "customHTTP",
          {
            schema: "trabajadores",

            filter: {
              where: [
                {
                  field: "payload->ubicaciones",
                  operator: "regexp",
                  value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
                },
                {
                  field: "payload->suspendido",
                  operator: "=",
                  value: false
                }
              ]
            }
          },
          this.cancelSource
        )
      ];

      const nominaTemplate = [
        this.$store.dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "nomina_analisis",
            params: {
              //fecha: this.datesGraph,
              fecha: this.datesGraph,
              ubicaciones: [this.ubicacionRaizValue]
              // cultivo_id: this.cropGraphs ? this.cropGraphs.value : ""
            }
          },
          cancelToken: this.cancelSource
        })
      ];

      this.isLoading = true;

      call.push(...nominaTemplate);
      Promise.all(call)
        .then(([trabajadores, nomina]) => {
          // console.table(nomina.data);
          this.items = trabajadores.data;
          this.itemsAnalisis = nomina.data;
          // Egresos
          this.itemsEgresos = trabajadores.data
            ? trabajadores.data.map(tra => {
                const actualHora = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "horas normales"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);
                const actualHoExtra = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "horas extras"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);


                const actualBono = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "bono"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);
                const actualCaja = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "caja"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);
                const actualPrestamos = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "prestamos"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);

                const actualVariable = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "variable"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);
                const actualImpuestos = nomina.data
                  .filter(
                    item =>
                      item.trabajador == tra.payload.nombre &&
                      item.tipo == "impuestos"
                  )
                  .reduce((acum, i) => {
                    acum += i.total;
                    return acum;
                  }, 0);

                return {
                  ...tra,
                  hora: actualHora ? `$${actualHora.toFixed(2)}` : "$0",
                  horaExtra: actualHoExtra ? `$${actualHoExtra.toFixed(2)}` : "$0",
                  variable: actualVariable
                    ? `$${actualVariable.toFixed(2)}`
                    : "$0",

                  bono: actualBono ? `$${actualBono.toFixed(2)}` : "$0",
                  caja: actualCaja ? `$${actualCaja.toFixed(2)}` : "$0",
                  prestamos: actualPrestamos ? `$${actualPrestamos.toFixed(2)}` : "$0",
                  impuestos: actualImpuestos
                    ? `$${actualImpuestos.toFixed(2)}`
                    : "$0",

                  total: `$${(
                    Number(actualHora.toFixed(2)) +
                    Number(actualHoExtra.toFixed(2)) +
                    Number(actualVariable.toFixed(2)) +

                    Number(actualBono.toFixed(2)) +
                    Number(actualCaja.toFixed(2)) +
                    Number(actualPrestamos.toFixed(2)) +
                    Number(actualImpuestos.toFixed(2))
                  ).toFixed(2)}`,
                  selected: false
                };
              })
            : [];

          this.totalTrabajador = this.itemsEgresos.reduce(
            (acum, item) => {
              console.log({acum, item})
              debugger
              acum["hora"] += Number(item.hora.replace("$", ""));
              acum["horaExtra"] += Number(item.horaExtra.replace("$", ""));
              acum["variable"] += Number(item.variable.replace("$", ""));

              acum["bono"] += Number(item.bono.replace("$", ""));
              acum["caja"] += Number(item.caja.replace("$", ""));
              acum["prestamos"] += Number(item.prestamos.replace("$", ""));
              acum["impuestos"] += Number(item.impuestos.replace("$", ""));

              acum["total"] += Number(item.total.replace("$", ""));
              return acum;
            },
            {
              name: "",
              hora: 0,
              horaExtra: 0,

              bono: 0,
              caja: 0,
              prestamos: 0,

              variable: 0,
              impuestos: 0,
              total: 0
            }
          );
          this.isLoading = false;
        })
        .catch(err => {
          if (err !== "Stop") {
            this.isLoading = false;
          }
        });
      // .finally(() => (this.isLoading = false));
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Stop");
        // console.log("cancel request done");
      }
    },
    openModal(item) {
      const actsNormales = this.itemsAnalisis
        .filter(
          i => i.trabajador == item.payload.nombre && i.tipo == "horas normales"
        )
        .reduce((acum, i) => {
          acum += i.cantidad;
          return acum;
        }, 0);
      const actsExtra = this.itemsAnalisis
        .filter(
          i => i.trabajador == item.payload.nombre && i.tipo == "horas extras"
        )
        .reduce((acum, i) => {
          acum += i.cantidad;
          return acum;
        }, 0);
      const actsVariables = this.itemsAnalisis
        .filter(
          i => i.trabajador == item.payload.nombre && i.tipo == "variable"
        )
        .reduce((acum, i) => {
          acum += i.cantidad;
          return acum;
        }, 0);
      const acts = this.itemsAnalisis.filter(
        i => i.trabajador == item.payload.nombre && i.tipo == "variable"
      );

      this.itemModal = {
        ...item,
        totalHoraNormal: actsNormales.toFixed(2),
        totalHoraExtra: actsExtra.toFixed(2),
        totalVariable: actsVariables.toFixed(2)
      };

      this.itemsModal = acts;

      this.infoModal = true;

      // console.log(this.itemsModal);
    },

    getTableLocations(item, type) {
      if (type == 1) {
        return this.itemsEgresos.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      } else if (type == 2) {
        return this.itemsIngresos.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      } else {
        return this.itemsProduccion.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      }
    },
    changeAnalisis(value) {
      if (value) {
        this.actualAnalisis = value;
      }
    },
    changeDate(e) {
      const datesValues = [
        moment(e.start).format("YYYY-MM-DD"),
        moment(e.end).format("YYYY-MM-DD")
      ];
      this.$store.dispatch("setDateGraph", datesValues);
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.layout {
  table-layout: fixed;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width-space {
  /* display: table-cell; */
  width: 11.11% !important;
}
.custom-width-td {
  width: 70%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100%;
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
.cursor-p {
  cursor: pointer;
}

@media (max-width: 768px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
